export enum BusinessDayConventionTypes {
  modifiedFollowing = 1,
  following = 2,
  previous = 3,
  modifiedPrevious = 4,
  unadjusted = 5,
}
